import Page from '../../classes/Page'
import Maps from '../../modules/Maps'

export default class SingleStore extends Page {
    constructor(id = 'single_store') {
        super({
            id,
            element: '[data-app-page]',
            elements: {
                map: '#map',
            },
        })

        this.map = null
    }

    async create() {
        super.create()

        this.createStickyTabs()

        if (!this.elements.map) {
            return
        }

        if (this.elements.map.dataset.location) {
            let location = JSON.parse(this.elements.map.dataset.location)

            if (location.lat && location.lng) {
                this.coordinates = {
                    lat: parseFloat(location.lat),
                    lng: parseFloat(location.lng),
                }

                this.id = this.elements.map.dataset.id
                this.title = this.elements.map.dataset.title
                this.website = location.website
                this.city = location.mark.city
                this.address = location.mark.address
                this.spaces = location.spaces
                this.filter = location.filter
                
                this.map = new Maps({
                    element: this.elements.map,
                    zoom: {
                        value: 12,
                        controls: {
                            enable: false,
                        }
                    },
                    coordinates: {
                        lat: this.coordinates.lat,
                        lng: this.coordinates.lng
                    },
                    ui: false,
                    wheel: false,
                    fullscreen: false,
                    streetView: false,
                    mapTypeControl: false,
                    draggable: true,
                    stores: [this.elements.map],
                })

                this.map.create({
                    search: null,
                    markers: true,
                }, true)
            }
        }
    }

    createStickyTabs() {
        this.tabs = document.querySelector('[data-flagship-tabs]')

        if (!this.tabs) {
            return
        }

        const header = document.querySelector('header')

        this.onTabsScroll = () => {
            this.tabs.classList.toggle('in-view', window.scrollY > (header ? header.clientHeight : 0))
        }

        window.addEventListener('scroll', this.onTabsScroll, { passive: true })
        this.onTabsScroll()
    }

    addEventListeners() {}

    destroy() {
        if (this.onTabsScroll) {
            window.removeEventListener('scroll', this.onTabsScroll)
        }

        super.destroy()
    }
}